// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__tUc_D","title":"InfoRow_title__1mDRQ"};